export default __webpack_public_path__ + "static/media/5.97a261b2.png";